import { Box, SxProps, Tooltip, Typography } from "@mui/material"
import { FunctionComponent } from "react"
import dialogSo from "stores/layout/dialogStore"
import { getRef } from "utils/humanize"



interface Props {
	uuid?: string
}

/**
 * E' un UUID cliccabile che copia il valore negli appunti
 */
const RefCmp: FunctionComponent<Props> = ({
	uuid,
}) => {

	// HANDLER
	const handleClick = () => {
		if (!uuid) return
		navigator.clipboard.writeText(uuid)
		dialogSo.dialogOpen({
			modal: false,
			text: `COPIED TO CLIPBOARD`,
		})
	}

	// RENDER
	const ref = getRef(uuid) ?? "--"

	return (
		<Tooltip title={`COPY TO CLIPBOARD`}>
			<Box sx={sxRoot}
				onClick={handleClick}
			>{ref}</Box>
		</Tooltip>
	)
}

export default RefCmp

const sxRoot: SxProps = {
	fontSize: "14px",
	fontWeight: 500,
	//textTransform: "uppercase",
	opacity: .7,
	backgroundColor: "#000",
	p: "0px 4px",
	cursor: "pointer",
	'&:hover': {
		opacity: 1,
	}
}

